export const getElementById = (idAttribute: string) => {
  const element = document.getElementById(idAttribute);

  if (!element) {
    console.warn(`Could not find element with id: ${idAttribute}`);
  }

  return element as HTMLElement;
};
